
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  // Guard against possible translation loading issues
  let t = (key: string) => key;
  try {
    const { t: translate } = useTranslation();
    if (typeof translate === 'function') {
      t = translate;
    }
  } catch (error) {
    console.error('Translation error in Footer:', error);
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-home-4-fill text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                WF &amp; Y Painting LLC
              </h3>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">{t('footerDescription')}</p>
            <div className="flex space-x-4">
              <a href="tel:770-875-6990" className="text-blue-400 hover:text-blue-300 transition-colors">
                <i className="ri-phone-fill text-xl"></i>
              </a>
              <a href="mailto:wr47090@gmail.com" className="text-blue-400 hover:text-blue-300 transition-colors">
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {t('services')}
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {t('gallery')}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  {t('contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-phone-fill text-blue-400"></i>
                <a href="tel:770-875-6990" className="text-gray-300 hover:text-white transition-colors">
                  770-875-6990
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-fill text-blue-400"></i>
                <span className="text-gray-300">Atlanta, Georgia</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-time-fill text-blue-400"></i>
                <span className="text-gray-300">Mon-Sat: 7AM-6PM</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 WF &amp; Y Painting LLC. {t('allRightsReserved')}
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            className="text-gray-400 hover:text-white text-sm transition-colors mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
